import React from 'react';
// tslint:disable-next-line:import-blacklist
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Item from './ui/Item';
import { isActionRoute } from '../../../Account/utils';
import { useTheme } from '../../../theme';
const SidebarItem = ({ className, route, isSelected, onClickCallback }) => {
    const { SidebarItem: css } = useTheme('SidebarItem');
    if (isActionRoute(route)) {
        return (React.createElement("div", { className: cn(css.sidebarItem__wrapper, className), onClick: () => {
                route.action();
                onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback();
            } },
            React.createElement(Item, { route: route, isSelected: isSelected })));
    }
    if (route.isRedirect) {
        return (React.createElement("a", { className: cn(css.sidebarItem__wrapper, className), href: route.pathname, target: "_blank", onClick: onClickCallback },
            React.createElement(Item, { route: route, isSelected: isSelected })));
    }
    return (React.createElement(Link, { className: cn(css.sidebarItem__wrapper, className), to: route.pathname, onClick: onClickCallback },
        React.createElement(Item, { route: route, isSelected: isSelected })));
};
export default SidebarItem;
